// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"12":"2591de90","74":"930fda6a","125":"4f349ebb","351":"51ecf23a","457":"f74625b8","551":"f08f88f6","640":"11126420","707":"2e9fd77d","808":"8b3cd065","828":"89358f49","842":"8df647c5","851":"ec3ecaab"}[chunkId] + ".chunk.js";
};